import { ReplaySubject } from 'rxjs';

import { LocalStorageKeyEnum } from '@shared-enums/local-storage.enum';
import { getProperty } from '@shared-helpers/array-object-helpers';

import { ApiService } from '../services/api.service';

export class StaticDataStoreItem {
  private readonly webServiceName: keyof ApiService | '';
  private readonly propertyLocation: string;

  public isReady = false;
  public value: any;
  public finishedSubject$ = new ReplaySubject(1);

  constructor(
    private readonly name: LocalStorageKeyEnum | string,
    private readonly valueType: string,
    private readonly apiContext: ApiService,
    readonly webServiceObj: { webServiceName: keyof ApiService | ''; propertyLocation?: string },
  ) {
    this.webServiceName = webServiceObj.webServiceName;
    this.propertyLocation = webServiceObj.propertyLocation ?? ''; //pretty sure this is not used anywhere
  }

  public getValue(queryParams?: Record<string, string>): this {
    this.value = this.tryLocal();
    this.handleFetch(queryParams ?? {});
    return this;
  }

  public tryLocal() {
    const stored = this.checkLocalStorage();
    if (!stored) return false;
    this.value = stored;
    this.isReady = true;
    this.finishedSubject$.next(stored);
    return stored;
  }

  private checkLocalStorage(): null | string | object | any[] {
    //TODO: This has a lot of overlap with the checkLocalStorage method in the helpers!
    const stored = localStorage.getItem(this.name);
    if (!stored || stored === 'undefined') return null;
    if (this.valueType === 'string') return stored;
    if (this.valueType === 'object' || this.valueType === 'array') return JSON.parse(stored);
    return null;
  }

  public updateLocalStorage(): void {
    //TODO: This has a lot of overlap with the updateLocalStorage method in the helpers!
    if (this.valueType === 'string') localStorage.setItem(this.name, this.value);
    if (this.valueType === 'object' || this.valueType === 'array') localStorage.setItem(this.name, JSON.stringify(this.value));
  }

  private handleFetch(queryParams: Record<string, string>): void {
    this.isReady = false;
    //TODO: This needs to not store string name of angular service methods and then call them by string, this is very unsafe and un-maintainable!
    //@ts-expect-error This is an EXTREMELY hacky way to call a method on a service by string, so there's no good way to make this happen safely like this and we have to expect a type error!
    this.apiContext[this.webServiceName](queryParams)
      .toPromise()
      .then((value: any) => {
        this.value = getProperty(value, this.propertyLocation);
        if (!this.isReady) this.finishedSubject$.next(() => this.value);
        this.finishedSubject$.complete();
        this.updateLocalStorage();
        this.isReady = true;
      });
  }
}

export function getStaticData(apiService: ApiService) {
  return {
    costCenters: new StaticDataStoreItem(LocalStorageKeyEnum.CostCenterList, 'array', apiService, {
      webServiceName: 'getCostCenters$',
    }).getValue({ ServiceLine: 'UTIL' }),
  };
}
